import React from "react";
import { Box, Grid, Card, Container, Typography } from "@mui/material";

// import React from "react";
// import { Box, Grid, Card, Container, Typography } from "@mui/material";

import all from "../../assets/images/Home/boss.gif";
import support from "../../assets/images/Home/24-hour-service.gif";
import increase from "../../assets/images/Home/friendship.gif";
import future from "../../assets/images/Home/metaverse.gif";
import incre from "../../assets/images/Home/population.gif";
import real from "../../assets/images/Home/analytics.gif";
import trans from "../../assets/images/Home/design.gif";
import global from "../../assets/images/Home/emerging-industries.gif";

// Features data
const FEATURES = [
  {
    icon: all,
    title: "All in one Solution",
    description:
      "Deliver assurance across all categories —from one unified solution.",
  },
  {
    icon: global,
    title: "Global Reach",
    description:
      "Seamless support in 190+ countries, trusted globally  leading assistance provider.",
  },
  {
    icon: support,
    title: "24/7 Emergency Support",
    description:
      "Round-the-clock global assistance that’s always ready when you need it most.",
  },
  {
    icon: increase,
    title: "Increase Customer Loyalty",
    description:
      "Improve satisfaction and retention with reliable, high-quality support experiences.",
  },
  {
    icon: future,
    title: "Future ready",
    description:
      "Use technology, automation, and real-time dashboards to enhance service delivery.",
  },
  {
    icon: incre,
    title: "Increased",
    description: "Customer stickiness through higher satisfaction",
  },
  {
    icon: real,
    title: "Real-Time Data Insights",
    description:
      "Make faster, smarter business decisions with access to deep performance analytics.",
  },
  {
    icon: trans,
    title: "Transparent by Design",
    description:
      "Gain full visibility into claims, actions, and outcomes with live digital tools.",
  },
];

const rootStyles = {
  textAlign: "center",
  padding: "0 0 30px 0px",
  marginTop: "-1.3rem",
};

const CARD_WIDTH = 276;
const CARD_HEIGHT = 170;

const WhyParthnerWithAcrossAssist = () => {
  // Split features into two rows of 4 cards each
  const rows = [FEATURES.slice(0, 4), FEATURES.slice(4, 8)];

  return (
    <Box
      sx={{
        py: 3,
        // background: "linear-gradient(90deg, #f5f7fa 0%, #e3eafc 100%)",
      }}
      className="why-partner-with-across-container"
    >
      <Box sx={rootStyles}>
        <Container maxWidth="lg" disableGutters sx={{ textAlign: "left" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 500,
              fontFamily: '"Poppins", serif',
              mb: 1,
              textAlign: "center",
              color: "black",
              letterSpacing: 0.5,
            }}
            className="main-heading-font-size"
          >
            Why Partner with Across Assist
          </Typography>
          <Box
            align="center"
            mt={{ xs: "1.2rem", sm: "1.2rem", md: "0.002rem" }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#263238",
                fontWeight: 400,
                fontFamily: '"Poppins", serif',
                mb: 2,
                textAlign: "center",
                maxWidth: 600,
                mx: "auto",
              }}
            >
              Trust, tech, and growth — your engine for smarter support and
              scalable success.
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 3,

              px: { xs: 4, sm: 0 },
            }}
          >
            {rows.map((row, rowIdx) => (
              <Grid
                container
                spacing={{ xs: 2, sm: 3, md: 4 }}
                justifyContent="center"
                alignItems="stretch"
                key={rowIdx}
                sx={{ mb: rowIdx === 0 ? { xs: 2, sm: 3, md: 4 } : 0 }}
              >
                {row.map((feature, colIdx) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    key={colIdx}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "stretch",
                    }}
                  >
                    <Card
                      sx={{
                        width: { xs: "100%", sm: "100%", md: CARD_WIDTH },
                        maxWidth: 400,
                        height: { xs: "auto", md: CARD_HEIGHT },
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        borderRadius: 4,
                        boxShadow: "0 4px 24px rgba(30, 64, 175, 0.10)",
                        background:
                          "linear-gradient(white, white) padding-box, linear-gradient(45deg, #e3eafc, #f5f7fa) border-box",
                        border: "1.5px solid #e3eafc",
                        transition:
                          "transform 0.4s cubic-bezier(.4,2,.6,1), box-shadow 0.4s cubic-bezier(.4,2,.6,1)",
                        "&:hover": {
                          transform: "translateY(-8px) scale(1.14)",
                          border: "1.5px solid #b6c6e3",
                        },
                        px: { xs: 2, sm: 3 },
                        py: { xs: 2, sm: 2 },
                      }}
                      elevation={0}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 1.5,
                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: 32,
                            mr: 2,
                            minWidth: 40,
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={feature.icon}
                            alt={feature.title}
                            className="gif-color-change"
                            style={{
                              width: 50,
                              height: 50,
                              objectFit: "contain",
                              // filter:
                              //   "drop-shadow(0 2px 6px rgba(30,64,175,0.08))",
                            }}
                          />
                        </Box>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: {
                              xs: "1.05rem",
                              sm: "1.15rem",
                              md: "1.25rem",
                            },
                            fontFamily: '"Poppins", serif',
                            fontWeight: 500,
                            color: "black",
                            letterSpacing: 0.1,
                          }}
                        >
                          {feature.title}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: { xs: 13.5, sm: 14.5 },
                          color: "#374151",
                          fontFamily: '"Poppins", serif',
                          minHeight: { xs: 0, sm: 40 },
                          lineHeight: 1.6,
                          letterSpacing: 0.02,
                        }}
                      >
                        {feature.description}
                      </Typography>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ))}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default WhyParthnerWithAcrossAssist;
